<vpfa-switch
  *ngIf="showSwitch"
  [parentFormGroup]="formGroup"
  [fc]="formGroup.get('control')"
  (switched)="emitAction()"
></vpfa-switch>
